import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import PropTypes from 'prop-types';

import axiosInstance from '../../api';
import StyledCard from '../../components/card/StyledCard';
import SERVER_API_URL from '../../config';
import LocaleText from '../../utils/localText';

export default function DeletedUserDataGrid({ columns, userList }) {
  const [categoryList, setCategoryList] = useState([]);

  // for tabs
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const getAllCategory = async () => {
      try {
        const response = await axiosInstance.get(`${SERVER_API_URL}/category/findAll`);

        if (response.status === 200) {
          setCategoryList(response.data);
          setValue(response.data[0].name);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getAllCategory();
  }, []);

  return (
    <StyledCard sx={{
      height: '80vh',
      '& .super-app-theme--header': {
        backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.primary.darkMode.lighter : theme.palette.grey[400],
      }
    }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
              {categoryList.map((category) => (
                <Tab key={category.name} label={category.name} value={category.name} />
              ))}
            </Tabs>
          </Box>
          {categoryList.map((category) => (
            <TabPanel key={category.name} value={category.name} sx={{ p: 0 }}>
              <DataGrid
                sx={{ pt: 0, height: '75vh', p: 2, '& .MuiDataGrid-row': { backgroundColor: (theme) => theme.palette.mode === 'dark' ? "" : theme.palette.error.lighter, borderWidth: 0.5, borderTopColor: (theme) => theme.palette.error.darker, borderTopStyle: 'dashed' } }}
                rows={userList.filter((user) => user.category.name === category.name)}
                columns={columns}
                pageSize={12}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterValues: [''],
                    },
                  },
                  pagination: { pageSize: 10 },
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                disableSelectionOnClickCell
                disableColumnFilter
                localeText={LocaleText.pagination}
              />
            </TabPanel>
          ))}
        </TabContext>
        {userList.length === 0 && <Typography sx={{ p: 10 }}> የተሰረዘ የተክታይ የለም።</Typography>}
      </Box>
    </StyledCard>
  );
}

DeletedUserDataGrid.propTypes = {
  columns: PropTypes.array.isRequired,
  userList: PropTypes.array.isRequired,
};
